import { render, staticRenderFns } from "./MyClosetPreview.vue?vue&type=template&id=533b1fda&scoped=true&functional=true&"
import script from "./MyClosetPreview.vue?vue&type=script&lang=js&"
export * from "./MyClosetPreview.vue?vue&type=script&lang=js&"
import style0 from "./MyClosetPreview.vue?vue&type=style&index=0&id=533b1fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "533b1fda",
  null
  
)

export default component.exports